"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
/**
 * Custom hook to get the current vertical scroll position and direction.
 *
 * @returns {number} The current vertical scroll position.
 */
const useScrollPosition = () => {
  const [scrollInfo, setScrollInfo] = (0, _react.useState)({
    scrollY: 0,
    scrollDirection: 'initial'
  });
  const requestRef = (0, _react.useRef)(null);
  const lastScrollYRef = (0, _react.useRef)(0);
  const handleScroll = (0, _react.useCallback)(() => {
    if (typeof window === 'undefined') return;
    if (requestRef.current === null) {
      requestRef.current = window.requestAnimationFrame(() => {
        const currentScrollY = window.scrollY;
        setScrollInfo(prev => {
          let scrollDirection = prev.scrollDirection;
          if (currentScrollY > lastScrollYRef.current) {
            scrollDirection = 'down';
          } else if (currentScrollY < lastScrollYRef.current) {
            scrollDirection = 'up';
          }
          return {
            scrollY: currentScrollY,
            scrollDirection
          };
        });
        lastScrollYRef.current = currentScrollY;
        requestRef.current = null;
      });
    }
  }, []);
  (0, _react.useEffect)(() => {
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (requestRef.current) {
        window.cancelAnimationFrame(requestRef.current);
      }
    };
  }, [handleScroll]);
  return scrollInfo;
};
var _default = exports.default = useScrollPosition;